import { setConfig, setNexusManifest } from '@metorial/frontend-config';

let coreApiUrl = import.meta.env.VITE_CORE_API_URL;
let privateApiUrl = import.meta.env.VITE_PRIVATE_API_URL ?? import.meta.env.PRIVATE_API_URL;

let metorialEnvironment = import.meta.env.VITE_METORIAL_ENV;
type MetorialEnvironment = 'production' | 'staging' | 'development';

let isMetorialEnvironment = (value: string): value is MetorialEnvironment => {
  return value === 'production' || value === 'staging' || value === 'development';
};

if (!coreApiUrl) throw new Error('CORE_API_URL is not defined');
if (!metorialEnvironment) throw new Error('METORIAL_ENV is not defined');
if (!isMetorialEnvironment(metorialEnvironment)) {
  throw new Error(`Invalid METORIAL_ENV: ${metorialEnvironment}`);
}

setConfig({
  apiUrl: coreApiUrl,
  publicApiUrl: coreApiUrl,

  environment: metorialEnvironment,

  auth: {
    authFrontendUrl: undefined,
    loginPath: '/auth/login',
    logoutPath: '/auth/logout',
    signupPath: '/auth/signup'
  }
});

// Upstream's enterprise shell provides this manifest; standalone, every slice
// is served by this app at the prefix its router mounts it on (router.tsx).
setNexusManifest({
  slices: [
    { id: 'index', access: { owner: 'self', pathname: '/' } },
    { id: 'product', access: { owner: 'self', pathname: '/i' } },
    { id: 'organization', access: { owner: 'self', pathname: '/o' } },
    { id: 'account', access: { owner: 'self', pathname: '/account' } },
    { id: 'join', access: { owner: 'self', pathname: '/join' } },
    // Not part of the OSS dashboard; links resolve locally instead of throwing.
    { id: 'documents', access: { owner: 'self', pathname: '/documents' } },
    { id: 'trust', access: { owner: 'self', pathname: '/trust' } },
    { id: 'support', access: { owner: 'self', pathname: '/support' } },
    { id: 'enterprise', access: { owner: 'self', pathname: '/enterprise' } }
  ]
});
